var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1L20.217 2.826C20.674 2.928 21 3.333 21 3.802L21 13.789C21 15.795 19.997 17.669 18.328 18.781L12 23L5.672 18.781C4.002 17.668 3 15.795 3 13.79L3 3.802C3 3.333 3.326 2.928 3.783 2.826L12 1ZM12 3.049L5 4.604L5 13.789C5 15.126 5.668 16.375 6.781 17.117L12 20.597L17.219 17.117C18.332 16.375 19 15.127 19 13.79L19 4.604L12 3.05L12 3.049ZM16.452 8.222L17.867 9.636L11.503 16L7.26 11.757L8.674 10.343L11.502 13.171L16.452 8.221L16.452 8.222Z",
    fill: "#7A869A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidate);
export default __webpack_public_path__ + "static/media/validate.f7a8908315cf038ce27d04e82c25a57d.svg";
export { ForwardRef as ReactComponent };